var map = {
	"./icon-stats-certificates.svg": 1476,
	"./icon-stats-courses.svg": 1477,
	"./icon-stats-exercises.svg": 1478,
	"./icon-stats-instructors.svg": 1479,
	"./icon-stats-projects.svg": 1480,
	"./icon-stats-rating.svg": 1481,
	"./icon-stats-reviews.svg": 1482,
	"./icon-stats-students.svg": 1483,
	"./icon-stats-video.svg": 1484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;